import { PawPrint, MapPin, Heart, ArrowUp } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramStory = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;
  
  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image as element for better html-to-image compatibility on iOS */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />
      {/* Top decorative bar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "8px",
          background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)",
          zIndex: 2,
        }}
      />

      {/* Logo top-center */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "120px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            background: "#4E8A6E",
            borderRadius: "32px",
            width: "120px",
            height: "120px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 8px 32px rgba(78,138,110,0.3)",
          }}
        >
          <PawPrint style={{ width: "64px", height: "64px", color: "#FFFFFF" }} />
        </div>
        <span style={{ fontSize: "48px", fontWeight: 800, color: "#2D5A3D", marginTop: "24px" }}>
          GdzieSchronisko
        </span>
        <span style={{ fontSize: "28px", color: "#6B8A7A", fontWeight: 600, marginTop: "8px" }}>
          Mapa Schronisk dla Zwierząt
        </span>
      </div>

      {/* Main content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 80px",
          marginTop: "-80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Main icon */}
        <div
          style={{
            width: "200px",
            height: "200px",
            background: "linear-gradient(135deg, #5D9A7D 0%, #4E8A6E 100%)",
            borderRadius: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "64px",
            boxShadow: "0 16px 48px rgba(78,138,110,0.35)",
          }}
        >
          <MapPin style={{ width: "100px", height: "100px", color: "#FFFFFF" }} />
        </div>

        <h1
          style={{
            fontSize: "72px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 32px",
            textAlign: "center",
            lineHeight: 1.15,
          }}
        >
          Znajdź schronisko<br />
          blisko siebie
        </h1>

        <p
          style={{
            fontSize: "40px",
            color: "#4A7A5E",
            margin: "0 0 64px",
            fontWeight: 600,
            textAlign: "center",
            lineHeight: 1.4,
          }}
        >
          Sprawdź aktualne potrzeby<br />
          i dowiedz się jak pomóc
        </p>

        {/* Feature pills */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
          }}
        >
          {["🗺️ Interaktywna mapa", "❤️ Aktualne potrzeby", "🐕 Spacery z psami"].map((text) => (
            <div
              key={text}
              style={{
                background: "rgba(255,255,255,0.95)",
                padding: "20px 48px",
                borderRadius: "50px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <span style={{ fontSize: "32px", fontWeight: 700, color: "#2D5A3D" }}>
                {text}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* CTA section */}
      <div
        style={{
          padding: "0 80px 100px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Swipe up indicator */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "40px",
          }}
        >
          <ArrowUp style={{ width: "48px", height: "48px", color: "#4E8A6E" }} />
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#4E8A6E", marginTop: "8px" }}>
            Przesuń w górę
          </span>
        </div>

        {/* Footer bar */}
        <div
          style={{
            width: "100%",
            background: "#4E8A6E",
            borderRadius: "50px",
            padding: "28px 48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <span style={{ fontSize: "36px", color: "white", fontWeight: 800 }}>
            GdzieSchronisko.pl
          </span>
          <span style={{ fontSize: "24px", color: "rgba(255,255,255,0.9)", fontWeight: 500 }}>
            mapa schronisk i ich aktualnych potrzeb
          </span>
        </div>
      </div>
    </div>
  );
};
